import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Collapse from 'react-bootstrap/Collapse'
import {useContext, useEffect, useState} from 'react'
import {isMobile, useMobileOrientation} from 'react-device-detect'

import Footer from '../footer/Footer'
import {Header} from '../header/Header.tsx'
import ScrollToTop from '../scroll/ScrollToTop'
import {SideMenu} from '../side_menu/SideMenu'
import {Store} from '../../../providers/MenuProvider'
import {StockAccessoriesNotification} from '../modal/StockAccessoriesNotification'
import {useStoreInformationModal} from '../../../store/useStoreInformationModal.ts'
import AuthContext from '../../../contexts/AuthContext'
import ModalCustom from '../modal/ModalCustom'

interface LayoutInterface {
    children: Node;
}

const Layout = ({children}: LayoutInterface) => {
    const {state: stateMenu, toggleMenu} = useContext(Store)
    const { isAuthenticated} = useContext(AuthContext)
    const {isPortrait} = useMobileOrientation()

    const [modalToDisplay, setModalToDisplay] = useState(null)
    const [reloadModal, setReloadModal] = useState(true)

    const {
        fetchInformationModal,
        modals: informationModals,
        count: informationModalCount,
        applyLvl,
        resetModalInformations
    } = useStoreInformationModal((state) => state)

    function handleConfirmation() {
        applyLvl(modalToDisplay)
        setReloadModal(true)
    }

    useEffect(() => {
        resetModalInformations()
    }, [])

    useEffect(() => {
        if (reloadModal && isAuthenticated) {
            fetchInformationModal()
            setReloadModal(false)
        }
    }, [reloadModal, isAuthenticated])

    useEffect(() => {
        setModalToDisplay(informationModals[0] ?? null)
    }, [informationModalCount])

  return (
      <Container fluid className="bg-white">
          <Row className={'flex-nowrap'}>
              {isMobile && isPortrait ? (
                  <>
                      <Collapse in={stateMenu.activeMenu}>
                          <Col
                              xs={9}
                              sm={7}
                              md={5}
                              lg={3}
                              xl={3}
                              className="side-menu bg-grey-light pt-6 p-4 min-vh-100 col-xxl-2 position-fixed"
                              id="menu-collapse">
                              <SideMenu toggleMenu={toggleMenu} />
                          </Col>
                      </Collapse>
                      <div
                          className={`d-lg-none overlay ${
                              stateMenu.activeMenu && 'active'
                          }`}
                          onClick={toggleMenu}></div>
                  </>
              ) : (
                  <Col
                      xs={9}
                      sm={9}
                      md={4}
                      lg={3}
                      xl={3}
                      className="side-menu bg-grey-light p-4 min-vh-100 col-xxl-2"
                      id="menu-collapse">
                      <SideMenu toggleMenu={toggleMenu} />
                      <StockAccessoriesNotification />
                  </Col>
              )}

              <Col className="wrapper px-0">
                  <Header toggleMenu={toggleMenu} />

                  <Container id={'globalContentContainer'} fluid size="lg">
                      <Row>{children}</Row>
                  </Container>

                  <Footer />
              </Col>
          </Row>
          <ScrollToTop />
          {modalToDisplay && (
              <ModalCustom
                  show
                  backdrop={'static'}
                  header
                  headerTitle={modalToDisplay.title}
                  contentClassname={'disable-style'}
                  content={
                      <div
                          dangerouslySetInnerHTML={{
                              __html: modalToDisplay.content,
                          }}></div>
                  }
                  onHide={() => setModalToDisplay(null)}
                  footer
                  buttonsFooter={[
                      {
                          text: 'Annuler',
                          classNames: 'ml-auto bg-danger',
                          func: () => setModalToDisplay(null),
                      },
                      {
                          text: 'Ok',
                          classNames: 'mr-auto',
                          func: () => handleConfirmation(),
                      },
                  ]}
              />
          )}
      </Container>
  )
}

export default Layout
